<template>
    <modal
        :active="active"
        :large="true"
        :title="title()"
        @closed="$emit('closed', true)"
    >
        <div class="columns is-tablet">
            <form-field
                class="column"
                inner-container-class="is-fullwidth"
                label="Lokation"
                :error="error.location_id"
            >
                <InputSelectSearch
                    v-model="location"
                    :options="filteredLocations"
                    label="full_name"
                    option-value-prop="id"
                    placeholder="Vælg lokation"
                    :append-to-body="true"
                    :filter="filterLocations"
                />
            </form-field>
            <form-field
                :error="error.count"
                class="column"
                label="Antal"
            >
                <InputText v-model="form.count" type="number"/>
            </form-field>
        </div>

        <template v-slot:footer class="has-space-between">
            <div class="footer-spacer">
                <div>
                    <button class="button is-default" @click="$emit('closed', true)">Annuller</button>
                    <button class="button is-primary" @click="create">{{ saveButtonText }}</button>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from '@elems/modal'
import {FormField, InputSelectSearch, InputText} from '@elems/form'
import {mapGetters} from "vuex";
import terms from '../../../store/terms';

export default {
    components: {
        Modal,
        FormField,
        InputSelectSearch,
        InputText,
    },
    props: {
        active: Boolean,
        item: Object,
    },
    data() {
        return {
            form: {
                item_id: null,
                location_id: null,
                count: '',
            },
            location: null,
            error: [],
        }
    },
    watch: {
        active() {
            scrollLock(this.active);
        },
        location() {
            this.form.location_id = this.location.id;
        },
    },
    computed: {
        ...mapGetters([
            'listLocations',
        ]),
        filteredLocations() {
            return this.listLocations.filter(location => this.item.itemLocations.findIndex(il => il.location.id === location.id) === -1);
        },
        saveButtonText() {
            return 'Tilknyt ny lokation'
        },
        apiUrl() {
            return `/api/item-locations`;
        }
    },
    methods: {
        filterLocations(options, search) {
            const terms = search.toLocaleLowerCase().split(' ');
            return options.filter(option => {
                return terms.every(term => {
                    return option.full_name.toLocaleLowerCase().indexOf(term) > -1
                });
            });
        },
        title() {
            return 'Tilknyt lokation og antal'
        },
        create() {
            window.axios.post(this.apiUrl, this.form)
                .then(({ data }) => {
                    this.$emit('closed')
                    this.$emit('created', data)
                    this.$store.dispatch('setSuccess', 'Lokationen er tilknyttet')
                })
                .catch(error => {
                    if (error.response && error.response.status === 422) {
                        this.error = error.response.data.errors
                    }
                });
        },
    },
    created() {
        this.$store.dispatch('loadLocations', this.reset);
        this.form.item_id = this.item.id;
    },
}
</script>

<style lang="scss" scoped>
.footer-spacer {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    width: 100%;
}

.customer-details {
    h4 {
        align-items: center;
        border-bottom: 1px solid #bbb;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        margin-bottom: 25px;

        i {
            transition: transform .3s ease-in-out;
        }
    }

    .column {
        display: none;
    }

    &.open {
        h4 i {
            transform: rotate(.5turn);
        }

        .column {
            display: block;
        }
    }
}

.column {
    padding: 0 0.75rem;
}
</style>
